/**
 * The six trivia creatures (projects/trivia): agy's sticker art (board
 * #194), cut out by projects/trivia/art/cutout.py. That script also wrote
 * creatureArt.json, which says where each creature's eyes sit on
 * Creature.jsx's 120-unit grid and the body colour for its eyelids (sampled
 * from the art, so it's data, not a theme colour). Creature.jsx draws the
 * moving pupils and the blink over the picture.
 */
import art from "./creatureArt.json";
import creature1 from "../../assets/trivia/creature-1.png";
import creature2 from "../../assets/trivia/creature-2.png";
import creature3 from "../../assets/trivia/creature-3.png";
import creature4 from "../../assets/trivia/creature-4.png";
import creature5 from "../../assets/trivia/creature-5.png";
import creature6 from "../../assets/trivia/creature-6.png";

const NAMES = ["Blob", "Bean", "Spike", "Tooth", "Ghost", "Cube"];
const SOURCES = [creature1, creature2, creature3, creature4, creature5, creature6];

export const CREATURES = NAMES.map((name, i) => ({
  name,
  src: SOURCES[i],
  eyes: art[String(i + 1)].eyes,
  lid: art[String(i + 1)].lid,
}));

/** The creature for a player's number, wrapping past the six. */
export function creatureFor(index) {
  const n = Number.isInteger(index) ? index : 0;
  return CREATURES[((n % CREATURES.length) + CREATURES.length) % CREATURES.length];
}

/**
 * Where a pupil sits inside its eye, in grid units from the eye's centre.
 * `toward` is the direction to look, in grid units relative to the eye
 * (null looks straight ahead); the pupil travels up to `reach` (one number,
 * or `{x, y}` for an oval eye) and eases off for points close by.
 */
export function pupilOffset(toward, reach) {
  if (!toward) return { dx: 0, dy: 0 };
  const length = Math.hypot(toward.dx, toward.dy);
  if (length === 0) return { dx: 0, dy: 0 };
  const rx = typeof reach === "number" ? reach : reach.x;
  const ry = typeof reach === "number" ? reach : reach.y;
  const travel = Math.min(1, length / 40);
  return { dx: (toward.dx / length) * travel * rx, dy: (toward.dy / length) * travel * ry };
}
